@if(show_heder == true){
<app-header [label]="page_name | plural"></app-header>
}
<div class="flex bg-white gap-4 items-center w-full p-4">
  <div class="flex gap-2 w-full">
    <div class="flex flex-col ">
      <p>Scripts Evaluated</p>
      <div class="bg-primary text-white p-2 rounded-lg text-center">114 - Scripts Evaluated</div>
    </div>
    <div class="flex flex-col ">
      <p>Scripts Checked</p>
      <div class="bg-gray-100 text-gray-900 p-2 rounded-lg text-center">0.0%</div>
    </div>
  </div>
  <div class="flex gap-2 w-full">
    <div class="w-full bg-gray-100 text-center p-2 rounded-lg text-gray-900 flex items-center justify-center">Total Evaluators: 2</div>
    <app-select-input class="w-full" label="Select Subject" [options]="[{title:'All Subject',value:'All Subject'},{title:'Artificial Intelligence Grade 9th (ARI-001)',value:'Artificial Intelligence Grade 9th (ARI-001'}]"></app-select-input>
    <app-select-input class="w-full" label="Select Faculty" [options]="[{title:'All Faculty',value:'All Faculty'},{title:'Rudra (F019)',value:'Rudra (F019)'},{title:'Divyanshi (F029)',value:''}]"></app-select-input>
  </div>
</div>
<app-ag-grid-list class="w-full" [list]="items" [colDefs]="cols" [itemName]="page_name" (bulkDelete)="bulk_delete($event)"></app-ag-grid-list>
<app-confirmation-popup #confirmation_delete_modal label="Delete {{page_name}}?" [delete_icon]="true" cancelText="No" confirmColor="bg-[#FA2912] text-[#FFFFFF]" confirmText="Yes" [is_mandatory]="true" (confirm_modal_clicked)="delete()" (close_modal_clicked)="confirmation_delete_modal.close()">
  This action cannot be undone, and all associated data will be permanently removed.
</app-confirmation-popup>